import {useEffect, useMemo, useState, useCallback} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Col, Row } from "antd";
import {
	Button,
	Loading
} from "~/components";
import {
	InputField,
	SelectField
} from "~/components/Forms";
import {handleRequest} from "~/utils";
import {productCategoryApi} from "~/api";

function ProductCategoryFormAddEdit({item, onAdd, onUpdate, reloadKey})
{
	const isEdit = Boolean(item?.id);
	const [options, setOptions] = useState({});

	const initialValues = useMemo(
		() => ({
			name: item?.name ?? "",
			parent_id: item?.parent_id ?? 0,
		}),
		[item]
	);

	const validationSchema = Yup.object().shape({
		name: Yup.string().nullable().required('Bạn phải điền tên danh mục')
	})

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() =>
	{
		reset(initialValues);
	}, [initialValues, reset]);

	const loadOptions = useCallback(async () => {
		let [error, response] = await handleRequest(productCategoryApi.options());
		if(!error && response?.data) {
			const opts = Object.entries(response.data).map(([value, label]) => ({
				value: parseInt(value),
				label
			}));
			setOptions({categories: opts});
		}
	}, []);

	useEffect(() => {
		loadOptions();
	}, [loadOptions, reloadKey]);

	const onSubmit = async (data) =>
	{
		if(isEdit)
		{
			await onUpdate(data, item);
		}
		else
		{
			await onAdd(data);
		}
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<Row gutter={10}>
				<Col span={12}>
					<Controller control={control} name="name" render={({ field }) => (
						<InputField
							label={"Tên danh mục"}
							errors={errors}
							{...field}
						/>
					)} />
				</Col>
				<Col span={12}>
					<Controller control={control} name="parent_id" render={({ field }) => (
						<SelectField
							label={"Danh mục cha"}
							options={options?.categories || []}
							errors={errors}
							{...field}
						/>
					)} />
				</Col>
			</Row>
			<div className="form-group d-flex justify-content-end">
				<Button primary type="submit">{isEdit ? 'Cập nhật' : 'Thêm danh mục'}</Button>
			</div>
		</form>
	)
}

export default ProductCategoryFormAddEdit;
